import { PayloadAction, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { setValidatedStorageItem } from "../core/Helper";
import { changeBookmarks, getBookmark } from "../components/Bookmarks";
import manifest = require("../../assets/manifest.json");
import { IFolder, IImage } from "../interfaces/Images";
import { IThread, IChatMessage, IUser, KeyCode, ISystemMessage, MessageType, IAppState, noUser } from "../interfaces/App";

interface IBookmarkEntry {
    guid: string;
    id: number;
    title: string;
    uri?: string;
    children?: IBookmarkEntry[];
}
import {
    getBookmarks,
    delBookmark,
    postBookmark,
    putBookmark,
    createBookmarks,
    loginUser,
    logout,
    register,
    getVersion,
    getCloudIndex,
    saveIndex,
    makeCloudIndex,
    getUser,
    addUser,
    delUser,
    updUser,
    getMusicIndex,
    getPlayLists,
    getMediaTitles,
    getMediaGroups,
    getTasks,
    logTime,
    getOrganizations,
    getPlayListDB,
    delMediaTrack,
    putPlayListDB,
    getChartLists,
    delMediaGroup,
    updateMediaTrack,
    getPicIndex,
    sendConfirm,
    getMessageByDay,
    sendPass,
    resetPW,
    addMessage,
    getThreads,
    createThread,
    updateThread,
    deleteThread,
    getSetup,
    uploadImage,
    getHello,
} from "../services/apiService";
import { IGroup, IPlayList, ITitle } from "../interfaces/Music";
import AppSetup from "../core/AppSetup";
import { ITask } from "../interfaces/Timelog";
import { getArticle, getIndex } from "../services/newsService";
import { INews } from "../interfaces/News";
import { postSubscription, postUnSubscription } from "../services/pushService";
import { getDetails, getFavorites, getStations, setFavorit } from "../services/tankerService";
import { ITankStation, ITankType } from "../interfaces/Tanker";


const initialState: IAppState = {
    message: "",
    status: [],
    loggedIn: false,
    time: new Date(),
    fontSize: 16,
    bookmarks: null,
    env: { api: "", app: manifest.version },
    pageCounter: 0,
    images: [],
    folders: [],
    playLists: [],
    playList: [],
    tracks: [],
    currentList: [],
    groups: [],
    chartLists: [],
    user: noUser,
    users: [],
    isAvatar: false,
    fogg: false,
    tasks: [],
    organizations: [],
    subtitle: "",
    confirm: undefined,
    mouseDown: false,
    news: [],
    pictures: {},
    keys: { left: 0, right: 0, esc: 0 },
    threads: [],
    settings: {
        rights: [],
    },
    tanker: {
        stations: [],
        stationDetail: null,
        type: ITankType.e5,
    }
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        initApp: (_: IAppState) => {
            // state.loggedIn = localStorage.getItem("AUTHTOKEN") !== null;
        },
        tick: (state) => {
            state.time = new Date(state.time.getTime() + 500);
        },
        incFontSize: (state: IAppState) => {
            state.fontSize = state.fontSize + 1;
        },
        decFontSize: (state: IAppState) => {
            state.fontSize = state.fontSize - 1;
        },
        setMessage: (state: IAppState, action: PayloadAction<ISystemMessage>) => {
            state.status.push({ ...action.payload, timestamp: new Date().getTime(), read: false });
        },
        setImageData: (state: IAppState, action: PayloadAction<{ idx: number, image: IImage }>) => {
            if (action.payload.idx === -1) {
                state.images = [];
            } else {
                state.images[action.payload.idx] = action.payload.image;
            }
        },
        setFolderData: (state: IAppState, action: PayloadAction<{ path: string, title: string }>) => {
            state.folders = state.folders.map((folder: IFolder) => {
                return { ...folder, title: folder.path === action.payload.path ? action.payload.title : folder.title }
            });
        },
        setAvatar: (state: IAppState, action: PayloadAction<boolean>) => {
            state.isAvatar = action.payload;
        },
        setFogg: (state: IAppState, action: PayloadAction<boolean>) => {
            state.fogg = action.payload;
        },
        setSubTitle: (state: IAppState, action: PayloadAction<string>) => {
            state.subtitle = action.payload;
        },
        publicateTracklist: (state: IAppState, action: PayloadAction<ITitle[]>) => {
            state.playList = [...action.payload];
        },
        slicePlayList: (state: IAppState, action: PayloadAction<number>) => {
            const newList = state.playList.slice(action.payload);
            state.playList = [...newList];
        },
        changeCurrentList: (state: IAppState, action: PayloadAction<{ title: ITitle, what: string }>) => {
            if (action.payload.what === 'add' && action.payload.title) {
                state.currentList.push(action.payload.title);
            } else if (action.payload.what === 'del' && action.payload.title) {
                state.currentList = [...state.currentList.filter((t: ITitle) => t.id !== action.payload.title.id)];
            } else {
                console.error("function changeCurrentList called with invalid params:", action.payload);
            }
        },
        clearTracks: (state: IAppState) => {
            state.tracks = [];
        },
        clearPlayList: (state: IAppState) => {
            state.currentList = [];
        },
        setTrackFlag: (state: IAppState, action: PayloadAction<{ idx: number, flag: boolean }>) => {
            state.tracks[action.payload.idx].flagged = action.payload.flag;
        },
        setCurrentFlag: (state: IAppState, action: PayloadAction<{ idx: number, flag: boolean }>) => {
            state.currentList[action.payload.idx].flagged = action.payload.flag;
        },
        setConfirm: (state: IAppState, action: PayloadAction<React.JSX.Element>) => {
            state.confirm = action.payload;
        },
        setCurrentPlayListName: (state: IAppState, action: PayloadAction<IPlayList>) => {
            state.playLists.forEach((pl: IPlayList) => { if (pl.id === action.payload.id) { pl.name = action.payload.name } })
        },
        setMouseDown: (state: IAppState, action: PayloadAction<boolean>) => {
            state.mouseDown = action.payload;
        },
        setMediaGroups: (state: IAppState, action: PayloadAction<IGroup[]>) => {
            state.groups = [...action.payload];
        },
        setKey: (state: IAppState, action: PayloadAction<KeyCode>) => {
            switch (action.payload) {
                case KeyCode.left: state.keys.left++; break;
                case KeyCode.right: state.keys.right++; break;
                case KeyCode.esc: state.keys.esc++; break;
                default: break;
            }
        },
        readSystemMessage: (state: IAppState, action: PayloadAction<number>) => {
            const msg = state.status.find((m: ISystemMessage) => m.timestamp === action.payload);
            msg.read = true;
        },
        clearDetail: (state: IAppState) => {
            state.tanker.stationDetail = undefined;
        },
        setTankerType: (state: IAppState, action: PayloadAction<any>) => {
            state.tanker.type = action.payload;
        }
    },
    extraReducers: (builder) => {
        return builder
            .addCase(getSetup.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.settings.rights = action.payload.data?.rights?.split(",");
            })
            .addCase(getBookmarks.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.bookmarks = action.payload.data;
            })
            // .addCase(saveBookmarks.fulfilled, (_: IAppState, _action: PayloadAction<any>) => {
            // })
            .addCase(delBookmark.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const bm = [state.bookmarks];
                if (changeBookmarks(bm, action.payload.data, null, null)) {
                    state.bookmarks = bm[0];
                }
            })
            .addCase(putBookmark.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload.data.toMove && action.payload.data.to) {
                    const toMove = action.payload.data.toMove;
                    const to = action.payload.data.to;
                    const type = action.payload.data.type;
                    const bm = [state.bookmarks];
                    const itemToMove = getBookmark(bm, toMove);
                    if (itemToMove) {
                        if (changeBookmarks(bm, toMove, null, null)) {
                            delete (itemToMove.guid);
                            if (changeBookmarks(bm, to, itemToMove, type, toMove)) {
                                state.bookmarks = bm[0];
                            }
                        }
                    }
                } else if (action.payload.data.guid) {
                    const item: IBookmarkEntry = action.payload.data;
                    const type: string = action.payload.data.type;
                    const bm = [state.bookmarks];
                    if (changeBookmarks(bm, item.guid, item, type, null)) {
                        state.bookmarks = bm[0];
                    }
                }
            })
            .addCase(postBookmark.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const item: IBookmarkEntry = action.payload.data.item;
                const guid: string = action.payload.data.guid;
                const type: string = action.payload.data.type;
                const newGuid = item.guid;
                delete item.guid;
                const bm = [state.bookmarks];
                if (changeBookmarks(bm, guid, item, type, newGuid)) {
                    state.bookmarks = bm[0];
                }
            })
            .addCase(createBookmarks.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.bookmarks = action.payload.data;
            })
            .addCase(loginUser.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                setValidatedStorageItem("AUTHTOKEN", action.payload.data.authtoken);
                state.status.push({ msg: action.payload.data.msg, type: MessageType.success, read: false, timestamp: new Date().getTime() });
                state.loggedIn = true;
                if (action?.payload?.data) {
                    const user = {
                        id: action.payload.data.id,
                        name: action.payload.data.name,
                        email: action.payload.data.email?.length > 0 ? action.payload.data.email : null,
                        phone: action.payload.data.phonenumber?.length > 0 ? action.payload.data.phonenumber : null,
                        rights: action.payload.data.rights,
                        readonly: action.payload.data.readonly === 1,
                        hasToken: action.payload.data.token ? true : false,
                        pushEnabled: action.payload.data.news_info === 1 ? true : false,
                        newsInfo: action.payload.data.news_info,
                    }
                    state.user = user;
                }

                // }
            })
            .addCase(resetPW.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                setValidatedStorageItem("AUTHTOKEN", action.payload.data.authtoken);
                state.status.push({ msg: action.payload.data.msg, type: MessageType.success, read: false, timestamp: new Date().getTime() });
                state.loggedIn = true;
                const user = {
                    id: action?.payload?.data?.id,
                    name: action?.payload?.data?.name,
                    email: action?.payload?.data?.email,
                    phone: action?.payload?.data.phonenumber,
                    rights: action?.payload?.data?.rights,
                    readonly: action?.payload.data.readonly === 1,
                    oldPass: action?.payload?.data?.oldPass,
                    hasToken: false,
                    newsInfo: action?.payload?.data?.news_info
                }
                state.user = user;
            })
            .addCase(loginUser.rejected, (state: IAppState, action: PayloadAction<any>) => {
                localStorage.removeItem("AUTHTOKEN");
                state.loggedIn = false;
                state.status.push({ msg: (action as any).error?.message, type: MessageType.error, read: false, timestamp: new Date().getTime() });
            })
            .addCase(register.rejected, (state: IAppState, _: PayloadAction<any>) => {
                localStorage.removeItem("AUTHTOKEN");
                state.loggedIn = false;
            })
            .addCase(register.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.status.push({ msg: action.payload.data, type: MessageType.success, read: false, timestamp: new Date().getTime() });
            })
            .addCase(logout.rejected, (state: IAppState, action: PayloadAction<any>) => {
                localStorage.removeItem("AUTHTOKEN");
                state.status.push({ msg: action.payload.error?.response?.data, type: MessageType.success, read: false, timestamp: new Date().getTime() });
                state.loggedIn = false;
                state.isAvatar = false;
            })
            .addCase(logout.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                localStorage.removeItem("AUTHTOKEN");
                state.status.push({ msg: action.payload.data.msg, type: MessageType.success, read: false, timestamp: new Date().getTime() });
                state.loggedIn = false;
                state.isAvatar = false;
                state.playLists = [];
                state.playList = [];
                state.currentList = [];
                state.groups = [];
                state.folders = [];
                state.tracks = [];
                state.images = [];
                state.pictures = {};
                state.user = noUser; // {...state.user, rights: ["user"]};
                state.threads = [];
                state.tanker.stations = [];
                state.tanker.stationDetail = undefined;

            })
            .addCase(getVersion.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const isReloaded = localStorage.getItem("RELOAD");
                if (action?.payload?.data?.version?.app
                    && state.env.app !== action?.payload?.data?.version?.app
                ) {
                    if (!isReloaded) {
                        const d = new Date();
                        console.log("upadate version from " + state.env.app + 'to ' + action.payload.data.version.app);
                        localStorage.setItem("RELOAD", String(d.getTime()));
                        //  window.location.reload();
                    } else {
                        console.error("can't update app version!");
                    }
                } else {
                    localStorage.removeItem('RELOAD');
                }
                state.env.api = action?.payload?.data?.version?.api;
                state.pageCounter = action?.payload?.data?.page_counter ? action?.payload?.data?.page_counter : "-";
            })
            .addCase(getCloudIndex.pending, (state: IAppState) => {
                state.folders = [];
                state.images = [];
            })
            .addCase(getCloudIndex.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.folders = action.payload.data.filter((e: any) => e.type === "folder").map((f: any) => { return { path: f.file, title: f.title } });
                let idx = 0;
                state.images = action.payload.data.filter((e: any) => e.type !== "folder").map((img: any) => {
                    return {
                        id: String(idx++),
                        file: img.file,
                        type: img.type,
                        size: img.size,
                        mtime: new Date(img.mtime),
                        atime: new Date(img.atime),
                        ctime: new Date(img.ctime),
                        data: img.data,
                        thumb: img.thumb,
                        big: img.big,
                        title: img.title,
                    }
                });
            })
            .addCase(getUser.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const u = action.payload.data;
                console.log(u);
                const u1 = u.map((e: any) => {
                    return {
                        id: String(e.user_id),
                        name: e.name,
                        email: e.email,
                        rights: e.rights ? e.rights : "",
                        register: e.register ? new Date(e.register) : null,
                        lastLogin: e.lastlogin ? new Date(e.lastlogin) : null,
                        token: e.token,
                        newsInfo: e.news_info
                    }
                });
                state.users = u1;
            })
            .addCase(addUser.pending, (state: IAppState, action: PayloadAction<any>) => {
                state.users.push({
                    id: null,
                    name: (action as any).meta.arg.name,
                    email: (action as any).meta.arg.email,
                    phone: (action as any).meta.arg.sms,
                    rights: (action as any).meta.arg.rights,
                    readonly: true,
                    hasToken: false,
                    newsInfo: 0
                });
            })
            .addCase(addUser.rejected, (state: IAppState, action: PayloadAction<any>) => {
                state.users = state.users.filter((u: IUser) => u.email !== (action as any).meta.arg.email);
                state.status.push({ msg: action.payload.error?.response?.data, type: MessageType.error, read: false, timestamp: new Date().getTime() });
            })
            .addCase(addUser.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.users = state.users.map((u: IUser) => { u.id = u.id ? u.id : action.payload.data?.id; return u; });
                state.status.push({ msg: "Benutzer angelegt", type: MessageType.success, read: false, timestamp: new Date().getTime() });
            })
            .addCase(updUser.pending, (state: IAppState, action: PayloadAction<any>) => {
                const idx = state.users.findIndex((u: IUser) => u.id === (action as any).meta.arg.id);
                console.log("found user-idx", idx);
                if (idx > -1) {
                    state.users[idx].name = (action as any).meta.arg.name;
                    state.users[idx].rights = (action as any).meta.arg.rights;
                }
            })
            .addCase(delUser.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.users = [...state.users.filter((u: IUser) => u.id !== action.payload.data)];
            })
            // .addCase(renewToken.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
            //   const idx = state.users.findIndex((u: IUser) => u.id === (action as any).meta.arg.id);
            //   if (idx > -1) {
            //     state.users[idx].name = (action as any).meta.arg.name;
            //     state.users[idx].rights = (action as any).meta.arg.rights;
            //   }
            // })
            .addCase(getMusicIndex.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.playLists = [];
                action.payload.data?.forEach((l: any) => state.playLists.push({ file: l.file }));
            })
            .addCase(getPlayLists.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.playLists = [{ name: "noname", id: "0" }];
                action.payload.data?.forEach((l: any) => state.playLists.push({ name: l.name, id: String(l.id) }));
            })
            .addCase(getPlayListDB.pending, (state: IAppState) => {
                state.currentList = [];
            })
            .addCase(getPlayListDB.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload.data) {
                    action.payload.data.forEach((track: any) => state.currentList.push({
                        id: track.id,
                        title: track.title,
                        audioSrc: track.audioSrc?.length > 0 ? AppSetup.getUserApiUrl() + track.audioSrc : "",
                        time: track.duration ? track.duration.replace(/^00:/, "") : 0,
                        flagged: false
                    }));
                }
            })
            .addCase(getMediaTitles.pending, (state: IAppState) => {
                state.tracks = [];
            })
            .addCase(getMediaTitles.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                action.payload.data?.forEach((track: any) => state.tracks.push({
                    id: track.id,
                    title: track.title,
                    audioSrc: track?.audioSrc ? AppSetup.getUserApiUrl() + track.audioSrc : null,
                    time: track.duration ? track.duration.replace(/^00:/, "") : "",
                }));
                // state.groups = [];
            })
            .addCase(getMediaGroups.pending, (state: IAppState) => {
                state.groups = [];
            })
            .addCase(getMediaGroups.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                action.payload.data?.forEach((group: IGroup) =>
                    state.groups.push({
                        name: group.name,
                        cnt: group.cnt,
                        id: group.id,
                    }));
                state.tracks = [];
            })
            .addCase(updateMediaTrack.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload.data.title_id && state.tracks) {
                    state.tracks.forEach((t: ITitle) => {
                        if (t.id === action.payload.data.title_id) {
                            t.title = action.payload.data.title;
                        }
                    });
                }
                action.payload.data?.forEach((group: IGroup) => state.groups.push({
                    name: group.name,
                    cnt: group.cnt,
                    id: group.id,
                }));
                state.tracks = [];
            })
            // .addCase(getFile.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
            //  console.log("getFile/fulfilled", action.payload)
            // })
            .addCase(getTasks.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.tasks = action.payload.data.map((res: any): ITask => {
                    return {
                        taskId: String(res.task_id),
                        task: res.task,
                        name: res.name,
                        organisation: res.organisation,
                        event: res.event,
                        latest: new Date(res.latest),
                    }
                });
            })
            .addCase(logTime.fulfilled, (_state: IAppState, _action: PayloadAction<any>) => {
                // console.log(action.payload.data);
            })
            .addCase(getOrganizations.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                action.payload.data.forEach((i: any) => state.organizations.push({ orgId: i.org_id, name: i.name }));
            })
            .addCase(delMediaTrack.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.playList = [...state.playList.filter((t: ITitle) => t.id !== String(action.payload.data))];
                state.tracks = [...state.tracks.filter((t: ITitle) => t.id !== String(action.payload.data))];
            })
            .addCase(putPlayListDB.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                switch (action.payload?.data?.state) {
                    case "upd":
                        state.playLists.forEach((pl: IPlayList) => {
                            if (pl.id === action.payload.data.list_id) {
                                pl.name = action.payload.data.name;
                            }
                        }
                        );
                        break;
                    case "new":
                        const newPl = state.playLists.find((pl: IPlayList) => pl.id === "0");
                        if (newPl) {
                            newPl.id = action.payload.data.list_id;
                            newPl.name = action.payload.data.name;
                            state.playLists.unshift({ name: "noname", id: "0" });
                        }
                        break;
                    case "del":
                        state.playLists = state.playLists.filter((pl: IPlayList) => pl.id !== action.payload.data.list_id);
                        break;
                    default:
                        console.log("playlist updated");
                }
            })
            .addCase(getChartLists.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                action.payload.data.forEach((cl: any) => state.chartLists.push({ name: cl.name, id: cl.id }));
            })
            .addCase(getIndex.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const news: INews[] = action.payload
                    .data?.sort((a: any, b: any) => a.grade - b.grade)
                    .map((a: any) => {
                        return {
                            grade: a.grade,
                            id: a.key,
                            title: a.title,
                            subTitle: a.subTitle,
                            class: a.class,
                            image: a.image,
                            date: new Date(a.date),
                            description: a.description,
                        }
                    });
                state.news = news;
            }
            )
            .addCase(getArticle.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const artIdx = state.news.findIndex((n: INews) => n.id === action.payload.data.key);
                if (artIdx > -1) {
                    state.news[artIdx] = { ...state.news[artIdx], content: action.payload.data.content }
                }
            })
            .addCase(delMediaGroup.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const groupId = action.payload.data;
                state.groups = [...state.groups.filter((g: IGroup) => g.id !== groupId)];
            })
            // .addCase(postMediaGroup.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
            //   action.payload.data.forEach((cl: any) => state.chartLists.push({name: cl.name, id: cl.id}));
            // })
            .addCase(getPicIndex.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.pictures = action.payload.data.cat;
            })
            .addCase(sendConfirm.pending, (state: IAppState, action: PayloadAction<any>) => {
                state.user.email = (action as any).meta.arg.email;
                state.user.phone = (action as any).meta.arg.sms;
            })
            .addCase(updUser.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.user.readonly = false;
                if (action.payload.data?.user) {
                    state.user.email = action.payload.data.user.email;
                    state.user.name = action.payload.data.user.name;;
                    state.user.phone = action.payload.data.user.phonenumber;
                    state.user.token = action.payload.data.user.token;
                    state.user.newsInfo = action.payload.data.user.news_info;
                    state.user.pushEnabled = action.payload.data.user.push_enabled;
                }
                state.status.push({ msg: action.payload.data.msg, type: MessageType.success, read: false, timestamp: new Date().getTime() });
            })
            .addCase(createThread.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload.data.thread_id) {
                    state.threads.push({
                        threadId: action.payload.data.thread_id,
                        name: action.payload.data.name,
                        members: action.payload.data.members.split(",").map((memberStr: string) => {
                            const member = memberStr.split(":");
                            return {
                                name: member[0],
                                userId: parseInt(member[1], 10),
                                admin: member[2] === "1",
                            };
                        }),
                        thread: []
                    });
                }
            })
            .addCase(getThreads.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.threads = [];
                if (action.payload?.data?.length > 0) {
                    action.payload.data.forEach((t: any) => {
                        state.threads.push({
                            threadId: t.thread_id,
                            days: t.days,
                            name: t.name,
                            members: t.members.split(",").map((memberStr: string) => {
                                const member = memberStr.split(":");
                                return {
                                    name: member[0],
                                    userId: parseInt(member[1], 10),
                                    admin: member[2] === "1",
                                };
                            }),
                            thread: []
                        });
                    });
                }
            })
            .addCase(updateThread.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload?.data?.thread_id) {
                    const newThread = action.payload?.data;
                    const temp = [...state.threads.filter((th: IThread) => th.threadId !== newThread.thread_id)];
                    temp.push({
                        threadId: newThread.thread_id,
                        days: newThread.days,
                        name: newThread.name,
                        members: newThread.members.split(",").map((memberStr: string) => {
                            const member = memberStr.split(":");
                            return {
                                name: member[0],
                                userId: parseInt(member[1], 10),
                                admin: member[2] === "1",
                            };
                        }),
                        thread: []
                    });
                    state.threads = [...temp];
                    state.status.push({ msg: "thread geändert", type: MessageType.success, read: false, timestamp: new Date().getTime() });
                }
            })
            .addCase(deleteThread.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload?.data?.thread_id) {
                    state.threads = [...state.threads.filter((th: IThread) => th.threadId !== action.payload.data.thread_id)];
                    state.status.push({ msg: "thread gelöscht", type: MessageType.success, read: false, timestamp: new Date().getTime() });
                }
            })
            .addCase(getMessageByDay.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload?.data?.thread_id) {
                    const threadIdx = state.threads?.findIndex((t: IThread) => t.threadId === action.payload.data.thread_id);
                    if (threadIdx > -1) {
                        state.threads[threadIdx].days = action.payload.data.days;
                        state.threads[threadIdx].thread = action.payload.data.thread.map((msg: any): IChatMessage => {
                            return {
                                id: msg.user_id,
                                name: msg.name,
                                timestamp: new Date(msg.created),
                                message: msg.message,
                                media: msg.media === 1 ? true : false,
                            }
                        });
                    }
                }
            })
            .addCase(addMessage.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload?.data?.thread_id) {
                    const threadIdx = state.threads.findIndex((t: IThread) => t.threadId === action.payload.data.thread_id);
                    if (threadIdx > -1) {
                        state.threads[threadIdx].thread.push({
                            id: action.payload.data.user_id,
                            name: action.payload.data.name,
                            timestamp: new Date(action.payload.data.created),
                            message: action.payload.data.message,
                            media: action.payload.data.media === 1 ? true : false
                        })
                    }
                }
            })
            .addCase(uploadImage.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                if (action.payload?.data?.thread_id) {
                    const threadIdx = state.threads.findIndex((t: IThread) => t.threadId === action.payload.data.thread_id);
                    if (threadIdx > -1) {
                        state.threads[threadIdx].thread.push({
                            id: action.payload.data.user_id,
                            name: action.payload.data.name,
                            timestamp: new Date(action.payload.data.created),
                            message: action.payload.data.message,
                            media: action.payload.data.media === 1 ? true : false
                        })
                    }
                }
            })
            .addCase(getHello.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.message = action.payload.data;
            })
            .addCase(postSubscription.fulfilled, (state: IAppState) => {
                state.user.pushEnabled = true;
            })
            .addCase(postUnSubscription.fulfilled, (state: IAppState) => {
                state.user.pushEnabled = false;
            })
            .addCase(getStations.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const stations: ITankStation[] = action.payload.data.map((s: any) => {
                    return {...s, favorit: !!s.favorit};
                });
                state.tanker.stations = stations;
            })
            .addCase(getDetails.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                console.log(action.payload.data);
                state.tanker.stationDetail = action.payload.data;
            })
            .addCase(setFavorit.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                state.tanker.stations = state.tanker.stations.map((s: ITankStation) => {
                    if ( s.id === action.payload.data.id) {
                        return {...s, favorit: !!action.payload.data.is_favorit};
                    } else {
                        return {...s};
                    }
                });
            })            
            .addCase(getFavorites.fulfilled, (state: IAppState, action: PayloadAction<any>) => {
                const stations: ITankStation[] = action.payload.data.map((s: any) => {
                    s.price = s.e5;
                    s.dist = 0;
                    return {...s, favorit: !!s.favorit}
                });
                state.tanker.stations = stations;
            })
            .addMatcher(
                isAnyOf(
                    getBookmarks.rejected,
                    getCloudIndex.rejected,
                    makeCloudIndex.rejected,
                    saveIndex.rejected,
                    register.rejected,
                    updUser.rejected,
                    getTasks.rejected,
                    logTime.rejected,
                    delMediaTrack.rejected,
                    getIndex.rejected,
                    getArticle.rejected,
                    delMediaGroup.rejected,
                    updateMediaTrack.rejected,
                    getPicIndex.rejected,
                    getMessageByDay.rejected,
                    delUser.rejected,
                    sendPass.rejected,
                    resetPW.rejected,
                    addMessage.rejected,
                    getThreads.rejected,
                    updateThread.rejected,
                    deleteThread.rejected,
                    uploadImage.rejected,
                    setFavorit.rejected,
                    getDetails.rejected,
                    getStations.rejected,
                    getFavorites.rejected,
                ), (state: IAppState, action: PayloadAction<any>) => {
                    state.status.push({ msg: action.payload?.error?.response?.data, type: MessageType.error, read: false, timestamp: new Date().getTime() });
                }
            )
            .addMatcher(
                isAnyOf(
                    saveIndex.fulfilled,
                    makeCloudIndex.fulfilled,
                    register.fulfilled,
                ), (state: IAppState, action: PayloadAction<any>) => {
                    state.status.push({ msg: action.payload?.data, type: MessageType.success, read: false, timestamp: new Date().getTime() });
                }
            );
    },
});

export const {
    tick,
    incFontSize,
    decFontSize,
    setMessage,
    initApp,
    setImageData,
    setFolderData,
    setAvatar,
    setFogg,
    setSubTitle,
    publicateTracklist,
    slicePlayList,
    changeCurrentList,
    clearTracks,
    clearPlayList,
    setTrackFlag,
    setCurrentFlag,
    setConfirm,
    setCurrentPlayListName,
    setMouseDown,
    setMediaGroups,
    setKey,
    readSystemMessage,
    clearDetail,
    setTankerType
} = appSlice.actions;
export default appSlice.reducer;
